<template>
    <div>
        <loading :active.sync="is_loading" :can-cancel="true" :is-full-page="true">
        </loading>
        <!-- Navbar -->
        <Navbar />

        <!-- Sidebar -->
        <SidebarConservation />
        <div id="main" class="main">
            <Breadcrumb :links="links" />
            <section class="section">
                <div class="card">
                    <div class="card-body">
                        <div class="form-group mb-3">
                            <label for="">Tahun</label>
                            <input type="text" class="form-control" v-model="data.tahun">
                        </div>
                        <div class="form-group mb-3">
                            <label for="">Lokasi</label>
                            <input type="text" class="form-control" v-model="data.lokasi">
                        </div>
                        <div class="form-group mb-3">
                            <label for="">Jenis Tanaman</label>
                            <input type="text" class="form-control" v-model="data.jenis_tanaman">
                        </div>
                        <div class="form-group mb-3">
                            <label for="">Unit Wilayah</label>
                            <input type="text" class="form-control" v-model="data.unit_wilayah">
                        </div>
                        <div class="form-group mb-3">
                            <label for="">Wilayah Sungai</label>
                            <input type="text" class="form-control" v-model="data.wilayah_sungai">
                        </div>
                        <div class="form-group mb-3">
                            <label for="">Latitude</label>
                            <input type="text" class="form-control" v-model="data.lat">
                        </div>
                        <div class="form-group mb-3">
                            <label for="">Longitude</label>
                            <input type="text" class="form-control" v-model="data.lng">
                        </div>
                        <div class="form-group mb-3">
                            <label for="">Jumlah</label>
                            <input type="number" class="form-control" v-model="data.jumlah">
                        </div>
                        <router-link to="/conservation/registration" class="btn btn-danger me-2"><i class="fa fa-times"></i> batal</router-link>
                        <button class="btn btn-primary" @click="save"><i class="fa fa-save"></i> simpan</button>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
// import
import Loading from 'vue-loading-overlay'
import Breadcrumb from '../../../components/Breadcrumb.vue'
// Component
import Navbar from '../../../components/Navbar.vue'
import SidebarConservation from '../../../components/SidebarConservation.vue'
import axios from 'axios'; // eslint-disable-line no-unused-vars

export default {
    components: {
        Loading,
        Breadcrumb,
        Navbar,
        SidebarConservation
    },
    data() {
        return {
            is_loading: false,
            links: [
                {url: '/dashboard', text:'Home'}, 
                {url: '/registration', text: 'Registrasi'},
                {url: '#', text: 'Tambah'}
            ],
            rows: [
                {
                    lokasi: '',
                    jenis_tanaman: '',
                    unit_wilayah: '',
                    wilayah_sungai: '',
                    lng: null,
                    lat: null,
                    jumlah: 0
                }
            ],
            year: new Date().getFullYear(),
            data: {}
        }
    },
    mounted() {
        this.is_loading = true;
        const { id } = this.$route.params;

        axios.get(`${this.$endpoints.conservation}/registrations/${id}`)
        .then(response => {
            this.data = response.data;
        }).finally(() => this.is_loading = false);
    },
    methods: {
        async save(){
            this.is_loading = true;

            try {
                const response = await axios.put(`${this.$endpoints.conservation}/registrations/${this.$route.params.id}`, {
                    data: this.data
                });

                this.$swal('Success', response.data.message, 'success');
                this.$router.push({name:'RegistrationIndex'});
            } catch (error) {
                console.error(error);
            }

            this.is_loading = false;
        }
    }
}
</script>

<style scoped>
#reg-table input:focus{
    outline: none!important;
    box-shadow: none!important;
}
</style>